// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgMoneyS3 = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect width={200} height={200} rx={40} fill="#005FFF" />
    <g transform="translate(-404.089 53.808) scale(0.9934)">
      <path
        d="M469.478,92.852q-12.27,0-20.626-3.849a28.742,28.742,0,0,1-12.629-10.524,27.825,27.825,0,0,1-4.27-15.334H453.6a9.989,9.989,0,0,0,1.741,5.712,11.288,11.288,0,0,0,5.234,4.03,27.7,27.7,0,0,0,16.9.24,11.221,11.221,0,0,0,5.05-3.367,8,8,0,0,0,1.745-5.173,6.7,6.7,0,0,0-3.247-5.953q-3.25-2.1-10.946-2.706l-5.653-.481q-13.592-1.2-21.649-8.54t-8.058-19.484a26.349,26.349,0,0,1,4.028-14.794,25.6,25.6,0,0,1,11.366-9.38A42.5,42.5,0,0,1,467.432,0q10.827,0,18.343,3.609A26.355,26.355,0,0,1,497.26,13.772a28.78,28.78,0,0,1,3.969,15.215H479.581a9.968,9.968,0,0,0-5.591-9.081,16.45,16.45,0,0,0-12.632-.24,8.357,8.357,0,0,0-3.726,3.187,8.518,8.518,0,0,0-1.265,4.57,8.074,8.074,0,0,0,2.287,5.773q2.283,2.407,7.936,2.887l5.655.481a53.084,53.084,0,0,1,17.439,4.269,29.477,29.477,0,0,1,11.907,9.321,23.715,23.715,0,0,1,4.331,14.433A25.659,25.659,0,0,1,501.531,79.5a28.257,28.257,0,0,1-12.51,9.862q-8.115,3.488-19.543,3.488"
        fill="#FFFFFF"
      />
      <path
        d="M569.779,34.162l9.511-13.708V2.664H516.6V22.916l39.2-.063L540.434,42.787a70.333,70.333,0,0,1,7.215.433c4.445.635,8.5,2.5,11.121,6.19a15.13,15.13,0,1,1-27.478,8.738v-2.31H511.813v2.31a34.654,34.654,0,0,0,34.614,34.614c20.715,0,36.194-14.414,36.194-34.614a28.248,28.248,0,0,0-12.842-23.986"
        fill="#FFFFFF"
      />
    </g>
  </svg>
);
export { SvgMoneyS3 };
